/**
 * EventTracker.ts
 *
 */
export default class EventTracker {
    static track(eventType, message) {
        try {
            const stack = new Error().stack;
            let callerInfo = '';
            if (stack) {
                const lines = stack.split('\n');
                // Zeile 0: 'Error', Zeile 1: aktuelle Funktion, Zeile 2: Aufrufer
                if (lines.length >= 3) {
                    const callerLine = lines[2].trim();
                    callerInfo = ` [Caller: ${callerLine}]`;
                }
            }
            message = message + callerInfo;
            fetch('/?type=1681981572', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams({
                    eventType,
                    message,
                }),
                credentials: 'include', // send fe_typo_user cookie
            });
        }
        catch (error) {
            console.error('EventTracker: Fehler beim Senden des Events', error);
        }
    }
}
// Beispiel:
// EventTracker.track('page-view', 'Home');
